var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.sectionsNumber > 0 ? _vm.sectionsNumber + " sections • " : "")+" "+_vm._s(_vm.resourcesNumber)+" resources")])
}
var staticRenderFns = []

export { render, staticRenderFns }